<template>
  <article class="feature-page">
    <div class="max-w-4xl mx-auto px-4 py-10">
      <h2 class="text-2xl lg:text-3xl font-bold text-center mb-4">
        piceditor.io Face Swap: Fun & Fast AI Face Swapping
      </h2>
      <p class="text-xl text-center mb-6">
        Easily swap faces in your images using advanced AI. Fun, fast, and incredibly realistic results.
      </p>

      <div class="landing-page-feature-descriptions">
        <div class="landing-page-feature-description">
          <div class="col-span-12 lg:col-span-7">
            <img src="@/images/landing_pages/face_swap/01.png" class="w-full" />
          </div>
          <div class="lg:order-first col-span-12 lg:col-span-5">
            <h4>Fun with Friends</h4>
            <p>
              Swap faces with multiple people in group photos with ease! Whether it's a party shot, a team photo, or a
              class reunion, our AI detects and swaps many faces automatically. Perfect for parties, pranks, or just
              sharing a laugh — and it all looks impressively natural.
            </p>
          </div>
        </div>

        <div class="landing-page-feature-description">
          <div class="col-span-12 lg:col-span-7">
            <img src="@/images/landing_pages/face_swap/02.png" class="w-full" />
          </div>
          <div class="col-span-12 lg:col-span-5">
            <h4>Create Viral Content</h4>
            <p>
              Want to go viral? Use our Face Swap to create jaw-dropping or laugh-out-loud content that’s ready for
              likes, shares, and duets. From meme-worthy moments to TikTok challenges, this tool is your secret weapon
              for fast, engaging content. Turn simple ideas into attention-grabbing swaps that your followers won’t stop
              talking about.
            </p>
          </div>
        </div>

        <div class="landing-page-feature-description">
          <div class="col-span-12 lg:col-span-7">
            <img src="@/images/landing_pages/face_swap/03.png" class="w-full" />
          </div>
          <div class="lg:order-first col-span-12 lg:col-span-5">
            <h4>Bring Characters to Life</h4>
            <p>
              Ever wondered what you'd look like as your favorite movie hero or a legendary figure from history? With
              our AI-powered Face Swap tool, you can step into any character’s shoes — literally. Whether it's a knight,
              a samurai, or a modern-day icon, turn imagination into vivid visuals. Perfect for roleplay, storytelling,
              cosplay concepts, or simply exploring different versions of yourself in a fun and creative way. Let your
              face become the canvas for your fantasy.
            </p>
          </div>
        </div>
      </div>

      <p class="mb-4">
        Our Face Swap tool uses cutting-edge AI to detect faces and seamlessly swap them in your uploaded images.
        Whether you're making content for fun or for social media engagement, it delivers natural, stunning results
        every time.
      </p>

      <h3 class="text-2xl font-bold mt-12 mb-6">Why Use Face Swap?</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 feature-page__specific">
        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/ai.png" alt="AI face swap" />
          <strong>AI Accuracy</strong>
          <p>Our smart AI detects faces and aligns features for ultra-realistic swaps that look like real photos.</p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/fun.png" alt="fun and creative" />
          <strong>Creative and Fun</strong>
          <p>Explore your creativity—swap faces for memes, celebrations, or just a good laugh with friends.</p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/speed.png" alt="fast processing" />
          <strong>Fast & Easy</strong>
          <p>Get your results in seconds. No editing skills needed—just upload and enjoy the transformation.</p>
        </div>
      </div>

      <h3 class="text-2xl font-bold mt-12 mb-6">How It Works</h3>
      <ol class="list-decimal pl-5 mb-6">
        <li>
          <strong>Upload Images:</strong> Upload a clear face image and a target image you want to apply the face onto.
        </li>
        <li>
          <strong>Select Options:</strong> Customize your swap with available settings like multi-face detection, NSFW
          content filtering, and more.
        </li>
        <li>
          <strong>Process with AI:</strong> Click to start the face swap. Our AI will handle everything in the
          background — just sit back and relax.
        </li>
        <li><strong>Preview Results:</strong> View the final swapped image with all selected options applied.</li>
        <li>
          <strong>Download & Share:</strong> Download the final result or share it instantly on your favorite platforms.
        </li>
      </ol>

      <p>
        Whether you're creating content, pranking a friend, or just playing around, our AI-powered Face Swap is the
        easiest and most fun way to remix your photos.
      </p>
    </div>
  </article>
</template>
